import { ERPUser } from '../../core/auth/types';

export function DashboardPage({ user }: { user: ERPUser }) {
  return (
    <div className="page">
      <div className="grid hero-grid">
        <section className="card hero-card">
          <p className="eyebrow">SPT ERP Final Test Run</p>
          <h1>Sardar Patel Travel Operating System</h1>
          <p>Integrated ERP foundation for CRM, Clients, Suppliers, Documents, Notifications, Bookings, Accounting, Users and Settings.</p>
          <div className="pill-row">
            <span className="pill">{user.role}</span>
            <span className="pill">{user.department}</span>
            <span className="pill">{user.status}</span>
          </div>
        </section>
        <section className="card check-card">
          <h2>Production Test Focus</h2>
          <ul>
            <li>Staff login and user profile</li>
            <li>CRM assignment by department</li>
            <li>Booking creation and accounting totals</li>
            <li>Documents upload/share workflow</li>
            <li>Notifications and WhatsApp actions</li>
          </ul>
        </section>
      </div>
      <div className="grid card-grid">
        <section className="card"><h3>CRM</h3><p>Inquiry capture, stages, assignment and follow-up reminders.</p></section>
        <section className="card"><h3>Masters</h3><p>Client and supplier records for long-term operational history.</p></section>
        <section className="card"><h3>Documents</h3><p>Passport, CC copy, invoice, receipt, refund, voucher and booking documents.</p></section>
        <section className="card"><h3>Finance</h3><p>Booking-linked sell, net, received, outstanding and supplier payable totals.</p></section>
      </div>
      <section className="card">
        <h3>Final Base Run Checklist</h3>
        <p className="muted">Create one staff login in Firebase Auth, add the same UID under Users, assign an inquiry, then test staff login, CRM access, Booking creation, Documents upload and Accounting totals.</p>
      </section>
    </div>
  );
}
